const CascadingChange = {
	cascadingDelete: (self, name) => {
		const taxonomyDataBucket = self.state.postData.TaxonomyData ? self.state.postData.TaxonomyData : {};
		const metadataBucket = self.state.postData.MetaData ? self.state.postData.MetaData : {};
		const taxonomyKeys = Object.keys(taxonomyDataBucket);
		const metadataKeys = Object.keys(metadataBucket);
		const formKeys = Object.keys(self.state.formData);
		const keyNames = [];
		taxonomyKeys.forEach((taxonomyKey) => {
			if (taxonomyDataBucket[taxonomyKey].parentName === name) {
				keyNames.push(taxonomyKey);
				delete taxonomyDataBucket[taxonomyKey];
			}
		});
		metadataKeys.forEach((metadataKey) => {
			if (metadataBucket[metadataKey].parentName === name) {
				keyNames.push(metadataKey);
				delete metadataBucket[metadataKey];
			}
		});
		formKeys.forEach((formKey) => {
			if (self.state.formData[formKey].parentName === name) {
				delete self.state.formData[formKey];
			}
		});
		if (keyNames.length > 0) {
			keyNames.forEach((key) => {
				CascadingChange.cascadingDelete(self, key);
			});
		}
	},
	cascadingAuditLevelDelete: (self, name, auditLevelConfig, auditLevel) => {
		const keyNames = [];
		const childDataKeys = auditLevelConfig.filter((field) => {
			return field.ParentName === name;
		});
		const auditLevelPostData = self.state.postData[auditLevel] || {};
		childDataKeys.forEach((childKey) => {
			keyNames.push(childKey.Name);
			delete auditLevelPostData[childKey.Name];
			self.state.formData[childKey.Name] = { disabled: false, parentName: null, value: "" };
		});
		if (keyNames.length) {
			keyNames.forEach((key) => {
				CascadingChange.cascadingAuditLevelDelete(self, key, auditLevelConfig, auditLevel);
			});
		}
	},
	cascadingAdvertiserDelete: (self, name, advertiser) => {
		if (self.state[advertiser] !== undefined) {
			const taxonomyDataBucket = self.state[advertiser].postData.TaxonomyData ? self.state[advertiser].postData.TaxonomyData : {};
			const metadataBucket = self.state[advertiser].postData.MetaData ? self.state[advertiser].postData.MetaData : {};
			const taxonomyKeys = Object.keys(taxonomyDataBucket);
			const metadataKeys = Object.keys(metadataBucket);
			const formKeys = Object.keys(self.state[advertiser].formData);
			const keyNames = [];
			taxonomyKeys.forEach((taxonomyKey) => {
				if (taxonomyDataBucket[taxonomyKey].parentName === name) {
					keyNames.push(taxonomyKey);
					delete taxonomyDataBucket[taxonomyKey];
				}
			});
			metadataKeys.forEach((metadataKey) => {
				if (metadataBucket[metadataKey].parentName === name) {
					keyNames.push(metadataKey);
					delete metadataBucket[metadataKey];
				}
			});
			formKeys.forEach((formKey) => {
				if (self?.state?.[advertiser]?.formData?.[formKey]?.parentName === name) {
					delete self?.state?.[advertiser]?.formData?.[formKey];
				}
			});
			if (keyNames.length > 0) {
				keyNames.forEach((key) => {
					CascadingChange.cascadingAdvertiserDelete(self, key, advertiser);
				});
			}
		}
	}
};

export default CascadingChange;
